import activityModels from '@/screens/home/schema/activityModels';
import { actionModels } from '@shared/schema/actionModels.js';

const getUpdateTitle = (update) => {
  if (activityModels?.[update?.model]?.(update?.presentation)?.title) {
    return activityModels?.[update?.model]?.(update?.presentation)?.title;
  }

  const extractMessage = (message) => {
    if (typeof message === 'object') {
      return message?.message || 'Error';
    }
    if (typeof message === 'string' && message.startsWith('{')) {
      try {
        const parsed = JSON.parse(message);
        return parsed?.message || 'Error';
      } catch (e) {
        return message;
      }
    }
    return message;
  };

  if (update?.actionStatus === 'error') {
    return update?.meta?.error?.message || extractMessage(update?.message) || 'Error';
  }
  if (update?.actionStatus === 'warn') {
    return extractMessage(update?.message) || 'Warning';
  }
  if (update?.actionStatus === 'info') {
    return extractMessage(update?.message) || 'Info';
  }
  return actionModels?.[update?.model]?.nickname || 'General';
};

export default getUpdateTitle;
